/** @format */

export const CartLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.133 24.8C8.51967 24.8 7.21434 26.12 7.21434 27.7333C7.21434 29.3466 8.51967 30.6666 10.133 30.6666C11.7463 30.6666 13.0663 29.3466 13.0663 27.7333C13.0663 26.12 11.7463 24.8 10.133 24.8ZM1.33301 1.33331V4.26665H4.26634L9.54634 15.3986L7.56634 18.992C7.33167 19.4026 7.19967 19.8866 7.19967 20.4C7.19967 22.0133 8.51967 23.3333 10.133 23.3333H27.733V20.4H10.749C10.5437 20.4 10.3823 20.2386 10.3823 20.0333L10.4263 19.8573L11.7463 17.4666H22.673C23.773 17.4666 24.741 16.8653 25.2397 15.956L30.4903 6.43731C30.6077 6.23198 30.6663 5.98265 30.6663 5.73331C30.6663 4.92665 30.0063 4.26665 29.1997 4.26665H7.50767L6.12901 1.33331H1.33301ZM24.7997 24.8C23.1863 24.8 21.881 26.12 21.881 27.7333C21.881 29.3466 23.1863 30.6666 24.7997 30.6666C26.413 30.6666 27.733 29.3466 27.733 27.7333C27.733 26.12 26.413 24.8 24.7997 24.8Z"
                fill={color}
            />
        </svg>
    );
};
